import React, { ButtonHTMLAttributes, FC, PropsWithChildren, useEffect } from "react"
import { Button, ButtonProps, Group, Modal, Stack, Text } from "@mantine/core"
import { useDisclosure } from "@mantine/hooks"
import { useLanguage } from "../../../../contexts/language-context"

type ConfirmModalButtonProps = ButtonProps & ButtonHTMLAttributes<HTMLButtonElement> & { text: string }

type ConfirmModalProps = {
    modalButton: ConfirmModalButtonProps
    openButton: ConfirmModalButtonProps
    loading: boolean
    modalTitle?: string
}

const ConfirmModal: FC<PropsWithChildren<ConfirmModalProps>> = ({ modalButton, openButton, modalTitle, loading, children }) => {
    const { L } = useLanguage()
    const [opened, { open, close }] = useDisclosure(false)
    const { onClick: onModalButtonClick, ...modalButtonProps } = modalButton

    const handleModalButtonClick: ButtonHTMLAttributes<HTMLButtonElement>["onClick"] = event => {
        close()
        onModalButtonClick?.(event)
    }

    useEffect(() => {
        if (!loading) close()
    }, [loading, close])

    return (
        <>
            <Modal opened={opened} onClose={close} title={modalTitle ?? openButton.text}>
                <Stack>
                    <Text mb="xs">
                        {children}
                    </Text>
                    <Group position="right" noWrap>
                        <Button variant="subtle" onClick={close}>
                            {L("Cancel")}
                        </Button>
                        <Button variant="filled" {...modalButtonProps} onClick={handleModalButtonClick}>
                            {modalButton.text}
                        </Button>
                    </Group>
                </Stack>
            </Modal>
            <Button onClick={open} loading={loading} {...openButton}>
                {openButton.text}
            </Button>
        </>
    )

}

export default ConfirmModal
